import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateAgo',
  standalone: true
})
export class DateAgoPipe implements PipeTransform {

  transform(value: Date | string): string | Date {
    let today = new Date();
    let yesterday = new Date();
    value = new Date(value);
    yesterday.setDate(yesterday.getDate() - 1);
    if (value.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (value.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    } else {
      let dd = value.getDate();
      let mm = value.toLocaleString('default', { month: 'short' });
      let yyyy = value.getFullYear();
      return `${dd} ${mm}, ${yyyy}`;
    }
  }

}
